document
  .querySelectorAll('.js-show-contract-modal')
  .forEach(el => {
    import('./contract-modal').then(({ default: _ }) => _(el))
  })

document
  .querySelectorAll('.js-show-invoice-modal')
  .forEach(el => {
    import('./invoice-modal').then(({ default: _ }) => _(el))
  })
